import storage from "./storage";
import axios from 'axios'

function get(value) {
  const prompts = storage.get("prompts")

  let label ='not find prompt!!'
  for(let i=0;i<prompts.length;i++){
    if (prompts[i].value === value) {
        label = prompts[i].label
    }
  }
  return label
}
function status(value) {
  const enabled = storage.get("enabled")
  return enabled
}
//校验编码
 function verificationCode(dataTable, billCode, billCodeVal) {

  let params = {
    "dataTable": dataTable,
    "billCode": billCode,
    "billCodeVal": billCodeVal,
  }
  return axios({
    method: 'post',
    url: 'bop/api/system/verificationCode/verificationBillCode',
    data: params
  })

}

async function fn(dataTable,billCode,billCodeVal) {
  let ifExistVal = false
  await verificationCode(dataTable,billCode,billCodeVal).then(res => {
    // false表示当前编码在当前数据库是唯一，相反true代表该编码已经存在
    ifExistVal = res.data[0].ifExistVal;
    // ifExistVal ? alert('通过检验') : alert('没通过检验')
  });
  return ifExistVal
}
// //校验编码
// async function verificationCode(dataTable,billCode,billCodeVal){
//   let ifExistVal = false;
//   let params ={
//     "dataTable":dataTable,
//     "billCode":billCode,
//     "billCodeVal":billCodeVal,
//   }
//   await axios({
//     method: 'post',
//     url: 'bop/api/system/verificationCode/verificationBillCode',
//     data: params
//   }).then(res =>{
//     // false表示当前编码在当前数据库是唯一，相反true代表该编码已经存在
//     ifExistVal = res.data[0].ifExistVal;
//     console.log("111"+ifExistVal)
//
//   })
//   return ifExistVal;
//
// }

export default {
  get,
  status,
  verificationCode,
  fn
}



// WEBPACK FOOTER //
// ./src/utils/prompts.js